import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=5a5feb46&scoped=true&"
import script from "./info-box.vue?vue&type=script&lang=js&"
export * from "./info-box.vue?vue&type=script&lang=js&"
import style0 from "./info-box.vue?vue&type=style&index=0&id=5a5feb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5feb46",
  null
  
)

export default component.exports